import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _single, _TechnicianExperticies } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { InputMoney } from "../../../theme/Input/InputMoney";

export const TechnicianExperticies = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_TechnicianExperticies);
    
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }
        instance.getTechnicianExperticiesCatalogPorPropiedades(props, null).then((resp: any) => {
            setLista(resp);
        }).catch(err => {
            toast.error("Error al cargar la lista de Experticies");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "name": `Agregar Experticie`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updateTechnicianExperticies(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDTechnicianExperticies', visible: true },
        { title: 'Experticie', property: 'Name', visible: true },
        { title: 'Valor/Hora', property: 'ValueHour', visible: true, mask: MASK_MONEY },
        { title: 'Descripción', property: 'Description', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Name", "ValueHour"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Experticies">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Nombre de la Experticie</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('ValueHour') ? 'has-error' : ''}`} >Valor/Hora</label>
                                <InputMoney _value={bean.ValueHour} onChange={(e) => { setBean({ ...bean, ValueHour: e }) }} _label=" " />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Month') ? 'has-error' : ''}`} >Descripción</label>
                                <textarea value={bean.Description} className="form-control" onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}